<div class="row">
  <!--<label>XY: {{CanLoadReport}}</label>-->
  <!--<div class="card">
    <div class="card-body">-->
  <div class="col-md-4 padding-bottom-5px" *ngFor="let l of CurrentMisReportDefByCategoryController">
    <div class="padding-all-5px animated bounce" *ngIf="l.RecordStatus=='A'">
      <div [ngSwitch]="l.DisplayType">
        <div *ngSwitchCase="'table'" class="animated bounce">
          <tablegraph [ReportType]='l.ReportName' [FromDate]='FromDate' [ToDate]='ToDate' [FacilityCode]='FacilityCode'
                      [DisplayType]='l.DisplayType' [FacilityName]='FacilityName'
                      [CanLoadReport]='CanLoadReport'></tablegraph>


        </div>
        <div *ngSwitchCase="'bar'" class="animated bounce">
          <bargraph [ReportType]='l.ReportName' [FromDate]='FromDate' [ToDate]='ToDate' [FacilityCode]='FacilityCode' [DisplayType]='l.DisplayType' [FacilityName]='FacilityName'
                    [CanLoadReport]='CanLoadReport'></bargraph>


        </div>
        <div *ngSwitchCase="'pie'" class="animated bounce">
          <piegraph [ReportType]='l.ReportName' [FromDate]='FromDate' [ToDate]='ToDate' [FacilityCode]='FacilityCode' [DisplayType]='l.DisplayType' [FacilityName]='FacilityName'
                    [CanLoadReport]='CanLoadReport'></piegraph>
        </div>
        <div *ngSwitchCase="'line'" class="animated bounce">
          <linegraph [ReportType]='l.ReportName' [FromDate]='FromDate' [ToDate]='ToDate' [FacilityCode]='FacilityCode' [DisplayType]='l.DisplayType' [FacilityName]='FacilityName'
                     [CanLoadReport]='CanLoadReport'></linegraph>
        </div>

        <div *ngSwitchCase="'polarArea'">
          <polarareagraph [ReportType]='l.ReportName' [FromDate]='FromDate' [ToDate]='ToDate' [FacilityCode]='FacilityCode' [DisplayType]='l.DisplayType' [FacilityName]='FacilityName'
                          [CanLoadReport]='CanLoadReport'></polarareagraph>
        </div>
        <div *ngSwitchCase="'doughnut'">
          <doughnutgraph [ReportType]='l.ReportName' [FromDate]='FromDate' [ToDate]='ToDate' [FacilityCode]='FacilityCode' [DisplayType]='l.DisplayType' [FacilityName]='FacilityName'
                         [CanLoadReport]='CanLoadReport'></doughnutgraph>
        </div>
        <div *ngSwitchCase="'radar'">
          <radargraph [ReportType]='l.ReportName' [FromDate]='FromDate' [ToDate]='ToDate' [FacilityCode]='FacilityCode' [DisplayType]='l.DisplayType' [FacilityName]='FacilityName'
                      [CanLoadReport]='CanLoadReport'></radargraph>
        </div>
        <div *ngSwitchCase="'horizontalBar'">
          <horizontalbargraph [ReportType]='l.ReportName' [FromDate]='FromDate' [ToDate]='ToDate' [FacilityCode]='FacilityCode' [DisplayType]='l.DisplayType' [FacilityName]='FacilityName'
                              [CanLoadReport]='CanLoadReport'></horizontalbargraph>
        </div>
        <div *ngSwitchDefault class="animated bounce">
          <linegraph [ReportType]='l.ReportName' [FromDate]='FromDate' [ToDate]='ToDate' [FacilityCode]='FacilityCode' [DisplayType]='l.DisplayType' [FacilityName]='FacilityName'
                     [CanLoadReport]='CanLoadReport'></linegraph>
        </div>
      </div>

    </div>
    <div class="padding-all-5px  animated bounce" *ngIf="l.RecordStatus!='A'">
      {{l.ReportName}} cannot be viewed!!
    </div>

    </div>
    <!--</div>
  </div>-->
  </div>
